import DashboardFooter from './DashboardFooter';

export default DashboardFooter;
